import React from 'react' // eslint-disable-line no-unused-vars
import '../../ui-elements/Modals'
import { Modal, ModalBody } from 'reactstrap'
import '../../css/ui-elements/modals.css'
import { referenceData, selectedCountry, listOfCountries } from '../../actions/referenceData'
import { setPermissionAction } from '../../actions/config'
import { switchLanguage } from '../language/actions'
import { connect } from 'react-redux'
import { initializeReferenceData } from '../../helpers/InitializeStoreData'
import { api } from '../index.api'

class ConferenceMI extends React.Component {
  constructor (props) {
    super(props)
    this.country = ''
    this._decodeURIComponentName = this._decodeURIComponentName.bind(this)
    this._submit = this._submit.bind(this)
    this._checkCountry = this._checkCountry.bind(this)
  }

  updateData ({ COUNTRY }) {
    this.setState({ countryCompleteData: COUNTRY })
    this.props.listOfCountries(COUNTRY)
  }

  componentDidMount () {
    api.fetchCountriesList(this.updateData.bind(this))
  }

  _decodeURIComponentName (key) {
    return decodeURIComponent(window.location.search.replace(new RegExp(`^(?:.*[&\\?]${encodeURIComponent(key).replace(/[*+.]/g, '\\$&')}(?:\\=([^&]*))?)?.*$`, 'i'), '$1'))
  }

  _checkCountry () {
    const passCountry = this._decodeURIComponentName('country')
    this.country = this.state.countryCompleteData.filter(({ name, abbrevation }) => (name.toUpperCase() === passCountry.toUpperCase()) || (abbrevation.toUpperCase() === passCountry.toUpperCase()))
  }

  _submit (e) {
    this._checkCountry()
    if (this.country.length === 0) {
      this.country = this.state.countryCompleteData.filter(({ name }) => name === 'United States')
    }
    const selectedCountryValue = this.country[0]
    const selectedUserType = 'HCP'
    const selectedLanguage = 'en' // dafault language for conference is English
    const actionDispatchers = {
      selectedCountry: this.props.selectedCountry,
      referenceData: this.props.referenceData,
      listOfCountries: this.props.listOfCountries,
      switchLanguage: this.props.switchLanguage,
      setPermissionAction: this.props.setPermissionAction
    }
    const isConference = true
    initializeReferenceData(selectedCountryValue, selectedUserType, selectedLanguage, actionDispatchers, isConference)
    this.props.toggle()
  }

  _cancel (e) {
    window.location.replace(window.location.href)
  }

  render () {
    return (
      <div>
        <Modal
          isOpen
          backdrop={false}
          keyboard={false}
          wrapClassName='modal-primary'
          size='lg'
        >
          <div className='modal-title-color'>
            <h3 className='text-center'>Welcome to AbbVie’s Medical Information Site</h3>
            <h5 className='mb-2 text-center'>The Health Care Professional’s Online Resource</h5>
          </div>
          <ModalBody>
            <p className='text-center'>I certify that this medical information request is made by a licensed healthcare professional and is entirely unsolicited by AbbVie personnel. I understand this request may be referred to an AbbVie office in a country other than my own for fulfillment, and that consent to the processing of personal data as per AbbVie's Privacy Policy is provided.</p>
            <p className='text-center'>This site is not intended for reporting adverse events or product complaints. AbbVie Employees are required to report suspected adverse events within one day of initial awareness.</p>
            <div className='text-center'>
              <button
                type='button'
                onClick={e => {
                  e.preventDefault()
                  this._cancel(e)
                }}
                className='btn btn-primary btn-outline hover m-r-5 submit-button btn-rounded'
              >
                <i className='sli-close' /> Cancel
              </button>
              <button
                type='submit' id = 'ok' className='btn btn-primary submit-button btn-rounded'
                onClick={e => {
                  e.preventDefault()
                  this._submit(e)
                }}
              > <i className='sli-check' /> Ok
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>)
  }
}

function mapStateToProps (state) {
  return {
    referenceData: state
  }
}

export default connect(mapStateToProps, { selectedCountry, referenceData, listOfCountries, switchLanguage, setPermissionAction })(ConferenceMI)



// WEBPACK FOOTER //
// ./src/mi-app/modals/ConferenceMI.js